import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AlertTriangle, X, ChevronDown, ChevronUp } from "lucide-react";

const HIDE_KEY = "missingFilesHiddenCount";

const readHidden = () => { try { return Number(sessionStorage.getItem(HIDE_KEY)) || 0; } catch { return 0; } };

// Floating warning listing documents whose file is gone from the server and must be uploaded again.
export default function MissingFilesNotice() {
  const location = useLocation();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [hiddenCount, setHiddenCount] = useState(readHidden);

  useEffect(() => {
    let cancelled = false;
    fetch("/api/missing-files", { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => { if (!cancelled && j?.success) setItems(j.data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [location.pathname]);

  if (items.length === 0 || items.length === hiddenCount) return null;

  const hide = () => {
    try { sessionStorage.setItem(HIDE_KEY, String(items.length)); } catch { /* ignore */ }
    setHiddenCount(items.length);
  };

  return (
    <div role="alert" style={{ position: "fixed", right: "20px", bottom: "20px", zIndex: 200, width: "min(380px, calc(100vw - 32px))", backgroundColor: "#FFF", border: "1px solid #FFCC80", borderLeft: "4px solid #F57C00", borderRadius: "10px", boxShadow: "0 8px 24px rgba(0,0,0,0.12)", fontSize: "13px", color: "#333" }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: "10px", padding: "12px 14px" }}>
        <AlertTriangle size={20} color="#F57C00" style={{ flexShrink: 0, marginTop: "1px" }} />
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600, marginBottom: "2px" }}>Chybí {items.length} {items.length === 1 ? "soubor" : items.length < 5 ? "soubory" : "souborů"}</div>
          <div style={{ color: "#666" }}>V ERP jsou evidované, ale soubor na serveru není. Je potřeba je znovu nahrát.</div>
          <button onClick={() => setOpen(!open)} style={{ marginTop: "6px", background: "none", border: "none", padding: 0, color: "#F57C00", cursor: "pointer", fontSize: "13px", fontWeight: 500, display: "flex", alignItems: "center", gap: "4px" }}>
            {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />} {open ? "Skrýt seznam" : "Zobrazit seznam"}
          </button>
        </div>
        <button onClick={hide} aria-label="Zavřít upozornění" title="Skrýt do příštího přihlášení" style={{ background: "none", border: "none", cursor: "pointer", padding: "2px" }}><X size={16} color="#999" /></button>
      </div>
      {open && (
        <ul style={{ listStyle: "none", margin: 0, padding: "0 14px 12px 44px", maxHeight: "260px", overflowY: "auto" }}>
          {items.map((it) => (
            <li key={it.kind + it.id} style={{ padding: "5px 0", borderTop: "1px solid #F3F3F3" }}>
              <Link to={it.link} style={{ color: "#1976D2", textDecoration: "none" }}>{it.original_name}</Link>
              <div style={{ color: "#999", fontSize: "12px" }}>{it.customer_name || "-"}{it.serial_number ? ` · SN ${it.serial_number}` : ""} · {it.document_name}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
